const quoteCharacters = /["“”]/;

export const useGetSmartQuoteReplacement = (
  text: string,
  quoteIndex: number
): string | undefined => {
  const currentQuote = text[quoteIndex];

  if (!quoteCharacters.test(currentQuote)) {
    return undefined;
  }

  const visibleText = text.endsWith("\n") ? text.slice(0, -1) : text;
  const hasNonQuoteText = /[^"“”\s]/.test(visibleText);

  if (!hasNonQuoteText) {
    return currentQuote === '"' ? undefined : '"';
  }

  const isOpenQuote = quoteIndex === 0 || /\s/.test(text[quoteIndex - 1]);

  if (currentQuote === '"') {
    return isOpenQuote ? "“" : "”";
  }

  if (isOpenQuote && currentQuote === "”") {
    return "“";
  }

  if (!isOpenQuote && currentQuote === "“") {
    return "”";
  }

  return undefined;
};
